import { Select, Tag } from 'antd'
import { useTicketStepContext } from 'features/libra/ticket/TicketStateContext'
import { Ban, Check, HelpCircle } from 'lucide-react'
import { Dispatch, FC, ReactNode, SetStateAction, useMemo } from 'react'
import styled from 'styled-components'

import { eligibilityValues, NiiReportTicketProps } from './niiReportApi'

const TAG_WIDTH = '100px'

const StyledTag = styled(Tag)`
  width: ${TAG_WIDTH};
  display: flex;
  align-items: center;
  gap: 0.25rem;
  justify-content: space-between;
`

const niiEligibilityLabels: Record<
  NonNullable<NiiReportTicketProps['eligibility']>,
  () => ReactNode
> = {
  eligible: () => (
    <StyledTag color='green'>
      <Check size={14} />
      <span>Eligible</span>
    </StyledTag>
  ),
  not_eligible: () => (
    <StyledTag color='red'>
      <Ban size={14} />
      <span>Not Eligible</span>
    </StyledTag>
  ),
  unclear: () => (
    <StyledTag color='orange'>
      <HelpCircle size={14} />
      <span>Unclear</span>
    </StyledTag>
  ),
}

export const NiiEligibilitySelect: FC<{
  eligibility: NiiReportTicketProps['eligibility']
  setEligibility: Dispatch<SetStateAction<NiiReportTicketProps['eligibility']>>
  width?: string
}> = ({ eligibility, setEligibility, width = '150px' }) => {
  const options = useMemo(
    () =>
      eligibilityValues.map((e) => ({
        value: e,
        label: niiEligibilityLabels[e](),
      })),
    []
  )

  const { isStepComplete } = useTicketStepContext()

  return (
    <Select
      value={eligibility}
      onChange={setEligibility}
      style={{ width }}
      options={options}
      disabled={isStepComplete}
    />
  )
}
